module.exports = __webpack_public_path__ + "assets/img/win.90d3876d.svg";